<ayn-select placeholder="Type the search" (valueChange)="onLanguageSelect.emit($event)">
  <ayn-option *ngFor="let language of languages | aynOptionFilter | async" [value]="language.value">
    {{ language.label }}
  </ayn-option>
</ayn-select>
